import CustomFields from './CustomFields.view';

export default CustomFields;
